import { __assign } from "tslib";
import { TicketStatus } from '@wix/answers-api';
import { AppEventType, createOneInboxLogger } from '../app';
import { createWixKbHandler } from './wix-kb';
import { createWixTicketHandler } from './wix-tickets';
import webBiLogger from '@wix/web-bi-logger';
import { getScreenParmeters } from '../handler/wix-utils';
var PROD_BI_HOST = '//frog.wix.com/wix-answers';
var DEV_BI_HOST = '//frog.wixpress.com/wix-answers';
var SRC = 77;
export var WixEventType;
(function (WixEventType) {
    WixEventType[WixEventType["ALPHA_EVENT"] = 42] = "ALPHA_EVENT";
    WixEventType[WixEventType["GENERAL_DEBUG_EVENT"] = 99] = "GENERAL_DEBUG_EVENT";
    WixEventType[WixEventType["GENERAL_GUIDE_ONBOARDING_EVENT"] = 901] = "GENERAL_GUIDE_ONBOARDING_EVENT";
    WixEventType[WixEventType["GENERAL_QUESTIONS_ONBOARDING_EVENT"] = 902] = "GENERAL_QUESTIONS_ONBOARDING_EVENT";
    WixEventType[WixEventType["ARTICLE_LINKED_TO_TICKET"] = 1001] = "ARTICLE_LINKED_TO_TICKET";
    WixEventType[WixEventType["ARTICLE_LINK_REMOVED_FROM_TICKET"] = 1002] = "ARTICLE_LINK_REMOVED_FROM_TICKET";
    WixEventType[WixEventType["ARTICLE_LINK_SUGGESTION_THUMBS_DOWN"] = 1003] = "ARTICLE_LINK_SUGGESTION_THUMBS_DOWN";
    WixEventType[WixEventType["APP_TICKETS_CHANGE_STATUS"] = 1008] = "APP_TICKETS_CHANGE_STATUS";
    WixEventType[WixEventType["APP_TICKETS_REPLY_ADDED"] = 1011] = "APP_TICKETS_REPLY_ADDED";
    WixEventType[WixEventType["APP_TICKETS_SAVED_REPLY_USED"] = 1018] = "APP_TICKETS_SAVED_REPLY_USED";
    WixEventType[WixEventType["APP_TICKETS_ADD_LABEL_CLICK"] = 1020] = "APP_TICKETS_ADD_LABEL_CLICK";
    WixEventType[WixEventType["APP_TICKETS_LABEL_ADDED"] = 1021] = "APP_TICKETS_LABEL_ADDED";
    WixEventType[WixEventType["APP_TICKETS_LABEL_REMOVED"] = 1022] = "APP_TICKETS_LABEL_REMOVED";
    WixEventType[WixEventType["APP_TICKET_ASSIGN"] = 1025] = "APP_TICKET_ASSIGN";
    WixEventType[WixEventType["APP_TICKET_SNOOZED"] = 1029] = "APP_TICKET_SNOOZED";
    WixEventType[WixEventType["APP_TEAM_MEMBERS_INVITES_SENT"] = 1203] = "APP_TEAM_MEMBERS_INVITES_SENT";
    WixEventType[WixEventType["APP_TEAM_MEMBERS_CREATED_GROUP"] = 1205] = "APP_TEAM_MEMBERS_CREATED_GROUP";
    WixEventType[WixEventType["APP_TEAM_MEMBERS_ADDED_GROUP_MEMBER"] = 1207] = "APP_TEAM_MEMBERS_ADDED_GROUP_MEMBER";
    WixEventType[WixEventType["WASABI_DASHBOARD_LOAD_START"] = 1320] = "WASABI_DASHBOARD_LOAD_START";
    WixEventType[WixEventType["WASABI_DASHBOARD_LOAD_COMPLETE"] = 1321] = "WASABI_DASHBOARD_LOAD_COMPLETE";
    WixEventType[WixEventType["WASABI_TILE_LOAD_START"] = 1322] = "WASABI_TILE_LOAD_START";
    WixEventType[WixEventType["WASABI_TILE_LOAD_COMPLETE"] = 1323] = "WASABI_TILE_LOAD_COMPLETE";
    WixEventType[WixEventType["WASABI_CLICK_ON_THREE_DOT"] = 1330] = "WASABI_CLICK_ON_THREE_DOT";
    WixEventType[WixEventType["WASABI_CREATE_NEW_REPORT"] = 1331] = "WASABI_CREATE_NEW_REPORT";
    WixEventType[WixEventType["WASABI_DELETE_REPORT"] = 1332] = "WASABI_DELETE_REPORT";
    WixEventType[WixEventType["APP_SETTINGS_CHANGE_ATTEMPT"] = 1450] = "APP_SETTINGS_CHANGE_ATTEMPT";
    WixEventType[WixEventType["APP_SETTINGS_CHANGE_SUCCESS"] = 1451] = "APP_SETTINGS_CHANGE_SUCCESS";
    WixEventType[WixEventType["APP_SETTINGS_CHANGE_FAIL"] = 1452] = "APP_SETTINGS_CHANGE_FAIL";
    WixEventType[WixEventType["APP_SETTINGS_ROLES_CLICK"] = 1453] = "APP_SETTINGS_ROLES_CLICK";
    WixEventType[WixEventType["APP_SETTINGS_ROLES_SELECT_ADD_CUSTOM_ROLE"] = 1454] = "APP_SETTINGS_ROLES_SELECT_ADD_CUSTOM_ROLE";
    WixEventType[WixEventType["APP_SETTINGS_ROLES_SELECT_EDIT"] = 1455] = "APP_SETTINGS_ROLES_SELECT_EDIT";
    WixEventType[WixEventType["PAYMENT_DETAILS_UPDATE_PAYMENT_CLICK"] = 1459] = "PAYMENT_DETAILS_UPDATE_PAYMENT_CLICK";
    WixEventType[WixEventType["PAYMENT_DETAILS_UPDATE_PAYMENT_ATTEMPT"] = 1460] = "PAYMENT_DETAILS_UPDATE_PAYMENT_ATTEMPT";
    WixEventType[WixEventType["PAYMENT_DETAILS_UPDATE_PAYMENT_SUCCESS"] = 1461] = "PAYMENT_DETAILS_UPDATE_PAYMENT_SUCCESS";
    WixEventType[WixEventType["PAYMENT_DETAILS_UPDATE_PAYMENT_FAIL"] = 1462] = "PAYMENT_DETAILS_UPDATE_PAYMENT_FAIL";
    WixEventType[WixEventType["PAYMENT_DETAILS_IFRAME_LOAD_FAIL"] = 1463] = "PAYMENT_DETAILS_IFRAME_LOAD_FAIL";
    WixEventType[WixEventType["PAYMENT_DETAILS_DIFFERENT_CARD_CLICK"] = 1464] = "PAYMENT_DETAILS_DIFFERENT_CARD_CLICK";
    WixEventType[WixEventType["PAYMENT_DETAILS_DOWNLOAD_INVOICE"] = 1465] = "PAYMENT_DETAILS_DOWNLOAD_INVOICE";
    WixEventType[WixEventType["PREMIUM_OPEN_PP"] = 1811] = "PREMIUM_OPEN_PP";
    WixEventType[WixEventType["PREMIUM_CLOSE_PP"] = 1812] = "PREMIUM_CLOSE_PP";
    WixEventType[WixEventType["PREMIUM_SELECT_TEAM_SIZE"] = 1813] = "PREMIUM_SELECT_TEAM_SIZE";
    WixEventType[WixEventType["PREMIUM_SELECT_CUSTOM_PLAN_PRODUCT"] = 1814] = "PREMIUM_SELECT_CUSTOM_PLAN_PRODUCT";
    WixEventType[WixEventType["PREMIUM_UNSELECT_CUSTOM_PLAN_PRODUCT"] = 1815] = "PREMIUM_UNSELECT_CUSTOM_PLAN_PRODUCT";
    WixEventType[WixEventType["PREMIUM_SELECT_PLAN_TYPE"] = 1816] = "PREMIUM_SELECT_PLAN_TYPE";
    WixEventType[WixEventType["PREMIUM_SELECT_SUBSCRIPTION_PLAN"] = 1817] = "PREMIUM_SELECT_SUBSCRIPTION_PLAN";
    WixEventType[WixEventType["PREMIUM_PROCEED_TO_CHECKOUT"] = 1818] = "PREMIUM_PROCEED_TO_CHECKOUT";
    WixEventType[WixEventType["PREMIUM_CLOSE_AFTER_SUCCESS"] = 1819] = "PREMIUM_CLOSE_AFTER_SUCCESS";
    WixEventType[WixEventType["PREMIUM_CONTACT_US"] = 1820] = "PREMIUM_CONTACT_US";
    WixEventType[WixEventType["PACKAGE_PICKER_LOAD_START"] = 1821] = "PACKAGE_PICKER_LOAD_START";
    WixEventType[WixEventType["PACKAGE_PICKER_LOAD_SUCCESS"] = 1822] = "PACKAGE_PICKER_LOAD_SUCCESS";
    WixEventType[WixEventType["PACKAGE_PICKER_HOVER_ON_PACKAGE"] = 1823] = "PACKAGE_PICKER_HOVER_ON_PACKAGE";
    WixEventType[WixEventType["PACKAGE_PICKER_SELECT_PACKAGE"] = 1824] = "PACKAGE_PICKER_SELECT_PACKAGE";
    WixEventType[WixEventType["PACKAGE_PICKER_SELECT_TEAM_SIZE"] = 1825] = "PACKAGE_PICKER_SELECT_TEAM_SIZE";
    WixEventType[WixEventType["PACKAGE_PICKER_SELECT_SUBSCRIPTION_CYCLE"] = 1826] = "PACKAGE_PICKER_SELECT_SUBSCRIPTION_CYCLE";
    WixEventType[WixEventType["PACKAGE_PICKER_ORDER_PREVIEW_RENDERED"] = 1827] = "PACKAGE_PICKER_ORDER_PREVIEW_RENDERED";
    WixEventType[WixEventType["PACKAGE_PICKER_ENTERPRISE_REQUEST_CALLBACK"] = 1828] = "PACKAGE_PICKER_ENTERPRISE_REQUEST_CALLBACK";
    WixEventType[WixEventType["PACKAGE_PICKER_CHECKOUT_ATTEMPT"] = 1829] = "PACKAGE_PICKER_CHECKOUT_ATTEMPT";
    WixEventType[WixEventType["PACKAGE_PICKER_CHECKOUT_SUCCESS"] = 1830] = "PACKAGE_PICKER_CHECKOUT_SUCCESS";
    WixEventType[WixEventType["PACKAGE_PICKER_CHECKOUT_FAIL"] = 1831] = "PACKAGE_PICKER_CHECKOUT_FAIL";
    WixEventType[WixEventType["PACKAGE_PICKER_PURCHASE_ATTEMPT"] = 1832] = "PACKAGE_PICKER_PURCHASE_ATTEMPT";
    WixEventType[WixEventType["PACKAGE_PICKER_PURCHASE_SUCCESS"] = 1833] = "PACKAGE_PICKER_PURCHASE_SUCCESS";
    WixEventType[WixEventType["PACKAGE_PICKER_PURCHASE_FAIL"] = 1834] = "PACKAGE_PICKER_PURCHASE_FAIL";
    WixEventType[WixEventType["PACKAGE_PICKER_PURCHASE_MODAL_LINK_CLICK"] = 1835] = "PACKAGE_PICKER_PURCHASE_MODAL_LINK_CLICK";
    WixEventType[WixEventType["PACKAGE_PICKER_HOVER_WHATS_INSIDE"] = 1836] = "PACKAGE_PICKER_HOVER_WHATS_INSIDE";
    WixEventType[WixEventType["PACKAGE_PICKER_PREVIOUS_STEP"] = 1837] = "PACKAGE_PICKER_PREVIOUS_STEP";
    WixEventType[WixEventType["PACKAGE_PICKER_VAT_CHANGED"] = 1838] = "PACKAGE_PICKER_VAT_CHANGED";
    WixEventType[WixEventType["PACKAGE_PICKER_PREVIEW_RENDER_FAIL"] = 1839] = "PACKAGE_PICKER_PREVIEW_RENDER_FAIL";
    WixEventType[WixEventType["PREMIUM_INCENTIVE_VIEW"] = 1851] = "PREMIUM_INCENTIVE_VIEW";
    WixEventType[WixEventType["PREMIUM_INCENTIVE_CTA"] = 1852] = "PREMIUM_INCENTIVE_CTA";
    WixEventType[WixEventType["PREMIUM_INCENTIVE_CONTACT_US_CLICK"] = 1855] = "PREMIUM_INCENTIVE_CONTACT_US_CLICK";
    WixEventType[WixEventType["CREDITS_INCENTIVE_VIEW"] = 1853] = "CREDITS_INCENTIVE_VIEW";
    WixEventType[WixEventType["CREDITS_INCENTIVE_CTA"] = 1854] = "CREDITS_INCENTIVE_CTA";
    WixEventType[WixEventType["CREDITS_MODAL_OPEN"] = 1861] = "CREDITS_MODAL_OPEN";
    WixEventType[WixEventType["CREDITS_MODAL_CLOSED"] = 1862] = "CREDITS_MODAL_CLOSED";
    WixEventType[WixEventType["CREDITS_MODAL_CTA_CLICK"] = 1863] = "CREDITS_MODAL_CTA_CLICK";
    WixEventType[WixEventType["CREDITS_MODAL_OPEN_PACKAGE_PICKER"] = 1864] = "CREDITS_MODAL_OPEN_PACKAGE_PICKER";
    WixEventType[WixEventType["CREDITS_MODAL_SELECT_AMOUNT"] = 1865] = "CREDITS_MODAL_SELECT_AMOUNT";
    WixEventType[WixEventType["CREDITS_MODAL_CLICK_CHECKOUT"] = 1866] = "CREDITS_MODAL_CLICK_CHECKOUT";
    WixEventType[WixEventType["CREDIT_PURCHASE_SUCCESS_OPEN"] = 1867] = "CREDIT_PURCHASE_SUCCESS_OPEN";
    WixEventType[WixEventType["CREDIT_PURCHASE_FAIL_OPEN"] = 1868] = "CREDIT_PURCHASE_FAIL_OPEN";
    WixEventType[WixEventType["APP_WELCOME_SCREEN_VIEW"] = 1901] = "APP_WELCOME_SCREEN_VIEW";
    WixEventType[WixEventType["APP_FTUE_LIGHTBOX_VIEW"] = 1947] = "APP_FTUE_LIGHTBOX_VIEW";
    WixEventType[WixEventType["APP_FTUE_LIGHTBOX_PLAY"] = 1948] = "APP_FTUE_LIGHTBOX_PLAY";
    WixEventType[WixEventType["APP_FTUE_LIGHTBOX_CLOSE"] = 1949] = "APP_FTUE_LIGHTBOX_CLOSE";
    WixEventType[WixEventType["APP_MODULE_LOAD_ATTEMPT"] = 1950] = "APP_MODULE_LOAD_ATTEMPT";
    WixEventType[WixEventType["APP_MODULE_LOAD_SUCCESS"] = 1951] = "APP_MODULE_LOAD_SUCCESS";
    WixEventType[WixEventType["APP_MODULE_LOAD_FAIL"] = 1952] = "APP_MODULE_LOAD_FAIL";
    WixEventType[WixEventType["APP_LOAD_ATTEMPT"] = 1954] = "APP_LOAD_ATTEMPT";
    WixEventType[WixEventType["APP_LOAD_SUCCESS"] = 1955] = "APP_LOAD_SUCCESS";
    WixEventType[WixEventType["ONE_INBOX_USER_ENGAGEMENT_EVENT"] = 1206] = "ONE_INBOX_USER_ENGAGEMENT_EVENT";
    WixEventType[WixEventType["ONE_INBOX_TICKET_LIST_LOAD"] = 1027] = "ONE_INBOX_TICKET_LIST_LOAD";
    WixEventType[WixEventType["ONE_INBOX_TICKET_PAGE_LOAD"] = 1028] = "ONE_INBOX_TICKET_PAGE_LOAD";
    WixEventType[WixEventType["ONE_INBOX_START_ACTIVE_SESSION"] = 1031] = "ONE_INBOX_START_ACTIVE_SESSION";
    WixEventType[WixEventType["CONTROL_ROOM_CLIENT_ENGAGMENT"] = 2600] = "CONTROL_ROOM_CLIENT_ENGAGMENT";
    WixEventType[WixEventType["CONTROL_ROOM_PAGE_LOAD_SUCCESS"] = 2601] = "CONTROL_ROOM_PAGE_LOAD_SUCCESS";
    WixEventType[WixEventType["APP_NOTIFICATIONS_CLIENT_ENGAGEMENT"] = 4902] = "APP_NOTIFICATIONS_CLIENT_ENGAGEMENT";
})(WixEventType || (WixEventType = {}));
var createEventUrl = function (type, data, isDebug) {
    if (data === void 0) { data = {}; }
    data.src = SRC;
    data.evid = type;
    var host = isDebug ? DEV_BI_HOST : PROD_BI_HOST;
    var queryPart = Object.keys(data).map(function (key) { return key + "=" + encodeURIComponent(data[key]); }).join('&');
    var ms = Date.now();
    return host + "?" + queryPart + "&_=" + ms;
};
var browserTabId = Date.now().toString(36);
export var logWixEvent = function (baseData, invokeRequest, isDebug, logger) { return function (eventType, data, pageLess) {
    if (data === void 0) { data = {}; }
    if (pageLess === void 0) { pageLess = false; }
    var combinedData = __assign(__assign({ tenant_id: baseData.tenantId, user_id: baseData.userId }, (pageLess ? {} : baseData.pageSpecific)), data);
    if (!!logger) {
        logger.log(__assign({ evid: eventType, src: SRC }, combinedData));
    }
    else {
        var eventUrl = createEventUrl(eventType, combinedData, isDebug);
        invokeRequest(eventUrl);
    }
    return Promise.resolve();
}; };
export var biPremiumFields = function (premiumFields) {
    // TODO - delete when old upgarde deleted
    var plan = premiumFields.planType;
    if (plan) {
        var isKB = plan.indexOf('KB') > -1;
        var isHD = plan.indexOf('HD') > -1;
        var isCC = plan.indexOf('CC') > -1;
        return {
            origin: premiumFields.origin === 'true' ? 'external' : premiumFields.origin,
            plan_price: premiumFields.planPrice || null,
            plan_type: isCC && isHD && isKB ? 'unlimited' : 'custom',
            product_knowledge_base: premiumFields.productKnowledgeBase,
            product_ticketing: premiumFields.productTicketing,
            product_call_center: premiumFields.productCallCenter,
            team_size: premiumFields.maxTeamSize || null,
            from_step: premiumFields.fromStep,
            subscription_type: premiumFields.subscriptionType,
        };
    }
    else {
        var selectedPlan = premiumFields.selectedPlans || [];
        var isKB = selectedPlan.indexOf('KB') > -1;
        var isHD = selectedPlan.indexOf('HD') > -1;
        var isCC = selectedPlan.indexOf('CC') > -1;
        var isLC = selectedPlan.indexOf('LC') > -1;
        var isAll = selectedPlan.indexOf('COMBO') > -1;
        return {
            origin: premiumFields.origin === 'true' ? 'external' : premiumFields.origin,
            plan_price: premiumFields.planPrice || null,
            plan_type: isAll ? 'unlimited' : 'custom',
            product_knowledge_base: isKB,
            product_ticketing: isHD,
            product_call_center: isCC,
            product_chat: isLC,
            team_size: premiumFields.maxTeamSize || null,
            from_step: premiumFields.fromStep,
            subscription_type: premiumFields.subscriptionType,
        };
    }
};
export var settingsSaveFields = function (eventData) {
    var changeContent = '';
    try {
        changeContent = JSON.stringify(eventData.additional || {});
    }
    catch (_a) {
        changeContent = 'Change Content Not Available';
    }
    var hcSettingsSourceName = eventData.sourceName ? { source_name: eventData.sourceName } : {};
    var lang = eventData.lang ? { lang: eventData.lang } : {};
    var errorReason = eventData.errorReason ? { errorReason: eventData.errorReason } : {};
    return __assign(__assign(__assign(__assign({ changeType: eventData.saveType, change_content: changeContent, section_key: eventData.key, page_url: window.location.href }, lang), errorReason), hcSettingsSourceName), { answers_brand_id: eventData.answers_brand_id });
};
export var createWixHandler = function (baseData, invokeRequest, isDebug, useBatch) {
    var loggerFactory = webBiLogger.factory({ useBatch: useBatch });
    var wixBiLogger = loggerFactory.logger({ endpoint: 'wix-answers' });
    var kbHandler = createWixKbHandler(baseData);
    var ticketHandler = createWixTicketHandler(baseData);
    var oneInboxLogger = createOneInboxLogger();
    // tslint:disable-next-line:cyclomatic-complexity
    return function (appEvent) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var wixLog = logWixEvent(baseData, invokeRequest, isDebug, useBatch ? wixBiLogger : undefined);
        var isInTicket = !!baseData.pageSpecific.ticket_id;
        var maybeTicketId = isInTicket ? baseData.pageSpecific.ticket_id : 'n/a';
        var event = appEvent;
        switch (event.type) {
            case AppEventType.ARTICLE_SAVE_ATTEMPT:
            case AppEventType.ARTICLE_SAVE_SUCCESS:
            case AppEventType.ARTICLE_DELETE:
            case AppEventType.ARTICLE_DELETE_CONFIRM:
            case AppEventType.ARTICLE_PUBLISH:
            case AppEventType.ARTICLE_PUBLISH_CONFIRM:
            case AppEventType.ARTICLE_PUBLISH_SUCCESS:
            case AppEventType.ARTICLE_UNPUBLISH:
            case AppEventType.ARTICLE_ASSIGN_CATEGORY:
            case AppEventType.ARTICLE_LIST_SEARCH:
            case AppEventType.ARTICLE_LIST_CREATE_NEW_ARTICLE:
            case AppEventType.ARTICLE_LIST_SELECT_ARTICLE:
            case AppEventType.CATEGORIES_ADD_CATEGORY_START:
            case AppEventType.CATEGORIES_ADD_CATEGORY_COMPLETE:
            case AppEventType.CATEGORIES_ADD_CATEGORY_CANCEL:
            case AppEventType.CATEGORIES_DELETE_CATEGORY:
            case AppEventType.CATEGORIES_CHANGE_ICON:
            case AppEventType.CATEGORIES_MOVE:
            case AppEventType.CATEGORIES_RENAME:
            case AppEventType.ARTICLE_ADD:
                return kbHandler(event);
            case AppEventType.TICKET_REPLY_ADD_ATTEMPT:
            case AppEventType.TICKET_REPLY_ADD_FAIL:
            case AppEventType.TICKET_TEAM_NOTE_ADD_ATTEMPT:
            case AppEventType.TICKET_TEAM_NOTE_ADD_FAIL:
            case AppEventType.TICKET_SWITCH_REPLY_TYPE:
            case AppEventType.TICKET_DELETE_TIMELINE_ITEM:
            case AppEventType.TICKET_DELETE_TIMELINE_ITEM_CONFIRM:
            case AppEventType.TICKET_DELETE_TIMELINE_ITEM_CANCEL:
            case AppEventType.TICKET_DELETE:
            case AppEventType.TICKET_DELETE_CONFIRM:
            case AppEventType.TICKET_CLICK_REPLY_AREA_ICON:
            case AppEventType.TICKET_REPLY_ADD_EMOJI:
            case AppEventType.TICKET_REPLY_ADD_ATTACHMENT:
            case AppEventType.TICKET_LIST_SEARCH:
            case AppEventType.TICKET_LIST_CREATE_TICKET_START:
            case AppEventType.TICKET_LIST_CREATE_TICKET:
            case AppEventType.TICKET_LIST_SELECT_TICKET:
                return ticketHandler(event);
            case AppEventType.ONE_INBOX_USER_ENGAGEMENT_EVENT:
                return oneInboxLogger(event.data);
            case AppEventType.ONE_INBOX_TICKET_LIST_LOAD: {
                return wixLog(WixEventType.ONE_INBOX_TICKET_LIST_LOAD, __assign(__assign(__assign({}, event.data), getScreenParmeters()), { answers_role_id: ((_c = (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.answersBackofficeSdk) === null || _b === void 0 ? void 0 : _b.currentAgent) === null || _c === void 0 ? void 0 : _c.roleId) || '' }));
            }
            case AppEventType.ONE_INBOX_TICKET_PAGE_LOAD: {
                return wixLog(WixEventType.ONE_INBOX_TICKET_PAGE_LOAD, __assign(__assign(__assign({}, event.data), getScreenParmeters()), { answers_role_id: ((_f = (_e = (_d = window) === null || _d === void 0 ? void 0 : _d.answersBackofficeSdk) === null || _e === void 0 ? void 0 : _e.currentAgent) === null || _f === void 0 ? void 0 : _f.roleId) || '' }));
            }
            case AppEventType.ONE_INBOX_START_ACTIVE_SESSION: {
                return wixLog(WixEventType.ONE_INBOX_START_ACTIVE_SESSION, __assign(__assign({}, event.data), { answers_role_id: ((_j = (_h = (_g = window) === null || _g === void 0 ? void 0 : _g.answersBackofficeSdk) === null || _h === void 0 ? void 0 : _h.currentAgent) === null || _j === void 0 ? void 0 : _j.roleId) || '' }));
            }
            case AppEventType.CONTROL_ROOM_CLIENT_ENGAGMENT: {
                return wixLog(WixEventType.CONTROL_ROOM_CLIENT_ENGAGMENT, __assign({}, event.data));
            }
            case AppEventType.CONTROL_ROOM_PAGE_LOAD_SUCCESS: {
                return wixLog(WixEventType.CONTROL_ROOM_PAGE_LOAD_SUCCESS, __assign({}, event.data));
            }
            case AppEventType.WASABI_DASHBOARD_LOAD_START: {
                return wixLog(WixEventType.WASABI_DASHBOARD_LOAD_START, __assign({}, event.data));
            }
            case AppEventType.WASABI_DASHBOARD_LOAD_COMPLETE: {
                return wixLog(WixEventType.WASABI_DASHBOARD_LOAD_COMPLETE, __assign({}, event.data));
            }
            case AppEventType.WASABI_TILE_LOAD_START: {
                return wixLog(WixEventType.WASABI_TILE_LOAD_START, __assign({}, event.data));
            }
            case AppEventType.WASABI_TILE_LOAD_COMPLETE: {
                return wixLog(WixEventType.WASABI_TILE_LOAD_COMPLETE, __assign({}, event.data));
            }
            case AppEventType.WASABI_CLICK_ON_THREE_DOT: {
                return wixLog(WixEventType.WASABI_CLICK_ON_THREE_DOT, __assign({}, event.data));
            }
            case AppEventType.WASABI_CREATE_NEW_REPORT: {
                return wixLog(WixEventType.WASABI_CREATE_NEW_REPORT, __assign({}, event.data));
            }
            case AppEventType.WASABI_DELETE_REPORT: {
                return wixLog(WixEventType.WASABI_DELETE_REPORT, __assign({}, event.data));
            }
            case AppEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_ATTEMPT: {
                return wixLog(WixEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_ATTEMPT, __assign({}, event.data));
            }
            case AppEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_SUCCESS: {
                return wixLog(WixEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_SUCCESS, __assign({}, event.data));
            }
            case AppEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_FAIL: {
                return wixLog(WixEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_FAIL, __assign({}, event.data));
            }
            case AppEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_CLICK: {
                return wixLog(WixEventType.PAYMENT_DETAILS_UPDATE_PAYMENT_CLICK, __assign({}, event.data));
            }
            case AppEventType.PAYMENT_DETAILS_IFRAME_LOAD_FAIL: {
                return wixLog(WixEventType.PAYMENT_DETAILS_IFRAME_LOAD_FAIL, __assign({}, event.data));
            }
            case AppEventType.PAYMENT_DETAILS_DIFFERENT_CARD_CLICK: {
                return wixLog(WixEventType.PAYMENT_DETAILS_DIFFERENT_CARD_CLICK, __assign({}, event.data));
            }
            case AppEventType.PAYMENT_DETAILS_DOWNLOAD_INVOICE: {
                return wixLog(WixEventType.PAYMENT_DETAILS_DOWNLOAD_INVOICE, __assign({}, event.data));
            }
            // perf related
            case AppEventType.MODULE_LOAD_ATTEMPT: {
                var eventData = event.data;
                return wixLog(WixEventType.APP_MODULE_LOAD_ATTEMPT, {
                    section_key: eventData.key,
                    page_url: window.location.href,
                    module: eventData.module,
                    answers_brand_id: eventData.answers_brand_id
                });
            }
            case AppEventType.MODULE_LOAD_SUCCESS: {
                var eventData = event.data;
                return wixLog(WixEventType.APP_MODULE_LOAD_SUCCESS, __assign(__assign({ section_key: eventData.key, page_url: window.location.href, module: eventData.module }, getScreenParmeters()), { answers_role_id: ((_m = (_l = (_k = window) === null || _k === void 0 ? void 0 : _k.answersBackofficeSdk) === null || _l === void 0 ? void 0 : _l.currentAgent) === null || _m === void 0 ? void 0 : _m.roleId) || '', answers_brand_id: event.data.answers_brand_id }), true);
            }
            case AppEventType.MODULE_LOAD_FAILURE: {
                var eventData = event.data;
                return wixLog(WixEventType.APP_MODULE_LOAD_FAIL, {
                    section_key: eventData.key,
                    page_url: window.location.href,
                    module: eventData.module,
                    answers_brand_id: eventData.answers_brand_id
                });
            }
            case AppEventType.LOAD_ATTEMPT: {
                return wixLog(WixEventType.APP_LOAD_ATTEMPT, {
                    page_url: window.location.href
                });
            }
            case AppEventType.ALPHA_EVENT: {
                var eventData = event.data;
                var params = '';
                try {
                    params = JSON.stringify(eventData.params);
                }
                catch (e) {
                    params = eventData.params + '(error stringifying data)';
                }
                return wixLog(WixEventType.ALPHA_EVENT, {
                    tab_id: browserTabId,
                    module: eventData.module,
                    feature: eventData.feature,
                    data: params,
                    type: eventData.type
                }, true);
            }
            case AppEventType.LOAD_SUCCESS: {
                return wixLog(WixEventType.APP_LOAD_SUCCESS, {
                    page_url: window.location.href
                });
            }
            case AppEventType.ARTICLE_LINKED_TO_TICKET: {
                var eventData = event.data;
                var rawOriginName = isInTicket ? eventData.meta.source : 'search-new-ticket';
                var originName = eventData.meta.expanded ? rawOriginName + '-expanded' : rawOriginName;
                var suggestedArticleIds = eventData.meta.suggestedArticleIds || [];
                var encodedSuggestedArticleIds = encodeURIComponent(suggestedArticleIds.join(','));
                if (isInTicket) {
                    return wixLog(WixEventType.ARTICLE_LINKED_TO_TICKET, {
                        article_name: eventData.article.title,
                        article_id: eventData.article.id,
                        ticket_id: maybeTicketId,
                        order_location: eventData.meta.order,
                        search_term: eventData.meta.searchTerm,
                        origin_name: originName,
                        attach_method: eventData.meta.attachMethod,
                        suggested_article_ids: encodedSuggestedArticleIds,
                        lang: eventData.article.locale,
                    });
                }
                return Promise.resolve();
            }
            case AppEventType.ARTICLE_TICKET_LINK_REMOVED: {
                var eventData = event.data;
                return wixLog(WixEventType.ARTICLE_LINK_REMOVED_FROM_TICKET, {
                    article_name: eventData.article.title,
                    article_id: eventData.article.id,
                    ticket_id: maybeTicketId,
                    lang: eventData.article.locale,
                });
            }
            case AppEventType.ARTICLE_TICKET_LINK_SUGGESTION_THUMBS_DOWN: {
                var eventData = event.data;
                return wixLog(WixEventType.ARTICLE_LINK_SUGGESTION_THUMBS_DOWN, {
                    article_name: eventData.article.title,
                    article_id: eventData.article.id,
                    ticket_id: maybeTicketId,
                    order_location: eventData.order,
                    search_term: eventData.searchTerm
                });
            }
            case AppEventType.TICKET_STATUS_CHANGE: {
                var eventData = event.data;
                return wixLog(WixEventType.APP_TICKETS_CHANGE_STATUS, {
                    ticket_id: eventData.ticket.id,
                    status_name: TicketStatus[eventData.status],
                    status_id: eventData.status
                });
            }
            case AppEventType.TICKET_REPLY_ADDED: {
                var _o = event.data, reply = _o.reply, newStatus = _o.newStatus;
                return wixLog(WixEventType.APP_TICKETS_REPLY_ADDED, {
                    reply_type: 'reply',
                    reply_id: reply.id,
                    resolution: TicketStatus[newStatus] || 'n/a',
                    ticket_id: reply.ticketId
                });
            }
            case AppEventType.TICKET_TEAM_NOTE_ADDED: {
                var note = event.data.note;
                return wixLog(WixEventType.APP_TICKETS_REPLY_ADDED, {
                    reply_type: 'team-note',
                    reply_id: note.id,
                    resolution: 'n/a - team note',
                    ticket_id: note.ticketId
                });
            }
            case AppEventType.SAVED_REPLY_USED: {
                var eventData = event.data;
                var savedReply = eventData.savedReply, replyType = eventData.replyType;
                return wixLog(WixEventType.APP_TICKETS_SAVED_REPLY_USED, {
                    ticket_id: maybeTicketId === 'n/a' ? null : maybeTicketId,
                    reply_id: savedReply.id,
                    shortcut: savedReply.shortcut,
                    content: savedReply.title,
                    lang: savedReply.locale,
                    reply_type: replyType,
                    results_option: eventData.source.type === 'search' ? eventData.source.filter : 'n/a - was shortcut',
                    source: eventData.source.type
                });
            }
            case AppEventType.TICKET_ADD_LABEL_BUTTON_CLICK: {
                var eventData = event.data;
                var ticket = eventData.ticket;
                return wixLog(WixEventType.APP_TICKETS_ADD_LABEL_CLICK, {
                    ticket_id: ticket.id
                });
            }
            case AppEventType.TICKET_ADD_LABEL: {
                var eventData = event.data;
                var ticket = eventData.ticket, label = eventData.label;
                return wixLog(WixEventType.APP_TICKETS_LABEL_ADDED, {
                    ticket_id: ticket.id,
                    is_new_label: false,
                    label_id: label.id,
                    label_name: label.name,
                    source: 'ticket page header'
                });
            }
            case AppEventType.TICKET_ADD_NEW_LABEL: {
                var eventData = event.data;
                var ticket = eventData.ticket, label = eventData.label;
                return wixLog(WixEventType.APP_TICKETS_LABEL_ADDED, {
                    ticket_id: ticket.id,
                    is_new_label: true,
                    label_id: label.id,
                    label_name: label.name,
                    source: 'ticket page header'
                });
            }
            case AppEventType.TICKET_REMOVE_LABEL: {
                var eventData = event.data;
                var ticket = eventData.ticket, label = eventData.label;
                return wixLog(WixEventType.APP_TICKETS_LABEL_REMOVED, {
                    ticket_id: ticket.id,
                    label_id: label.id,
                    label_name: label.name,
                    source: 'ticket page header'
                });
            }
            case AppEventType.TICKET_ASSIGN: {
                var _p = event.data, operator = _p.operator, agentOrGroup = _p.agentOrGroup, ticketId = _p.ticketId;
                return wixLog(WixEventType.APP_TICKET_ASSIGN, {
                    to_entity_name: agentOrGroup.name,
                    to_entity_id: agentOrGroup.id,
                    to_entity_type: agentOrGroup.type,
                    operator: operator,
                    ticket_id: ticketId
                });
            }
            case AppEventType.TICKET_SNOOZED: {
                var snoozeData = event.data;
                return wixLog(WixEventType.APP_TICKET_SNOOZED, {
                    ticket_id: snoozeData.ticketId,
                    is_from_bulk: snoozeData.bulk,
                    is_snooze_update: snoozeData.isUpdate,
                    snooze_id: snoozeData.snoozeId,
                    snooze_time: snoozeData.snoozeDate,
                    last_snooze_time: snoozeData.lastSnoozeDate,
                    snooze_type: snoozeData.snoozeType,
                    change_status_to_open: snoozeData.reopenOnSnooze,
                    costumer_reply_unsnooze: snoozeData.cancelOnUserReply,
                    send_notification: snoozeData.notifyOnSnoozeDate,
                    week_start_day: snoozeData.weekStartsMonday ? 'Monday' : 'Sunday',
                });
            }
            case AppEventType.PUBSUB_DEBUG:
            case AppEventType.RT_DEBUG:
            case AppEventType.PHONE_DEBUG: {
                var eventData = event.data;
                var type = eventData.type;
                var itemId = eventData.itemId;
                var data = '';
                try {
                    data = JSON.stringify(__assign({}, eventData.data));
                }
                catch (e) {
                    data = 'Error serializing data in Wix handler';
                }
                return wixLog(WixEventType.GENERAL_DEBUG_EVENT, {
                    data: data,
                    type: type,
                    tab_id: browserTabId,
                    item_id: itemId
                }, true);
            }
            case AppEventType.ONBOARDING_GUIDE_GENERIC_EVENT: {
                return wixLog(WixEventType.GENERAL_GUIDE_ONBOARDING_EVENT, {
                    type: event.data.type,
                    params: event.data.param
                }, true);
            }
            case AppEventType.ONBOARDING_QUESTIONS_GENERIC_EVENT: {
                return wixLog(WixEventType.GENERAL_QUESTIONS_ONBOARDING_EVENT, {
                    type: event.data.type,
                    params: event.data.param
                }, true);
            }
            case AppEventType.APP_NOTIFICATIONS_CLIENT_ENGAGEMENT: {
                return wixLog(WixEventType.APP_NOTIFICATIONS_CLIENT_ENGAGEMENT, {
                    engagement: event.data.engagement,
                    data: event.data.data,
                    role_id: event.data.role_id,
                    tenant_id: event.data.tenant_id,
                    lang: event.data.lang,
                    user_id: event.data.user_id,
                }, true);
            }
            case AppEventType.PREMIUM_OPEN_PP: {
                var eventData = event.data;
                return wixLog(WixEventType.PREMIUM_OPEN_PP, {
                    origin: eventData.origin
                });
            }
            case AppEventType.PREMIUM_CONTACT_US: {
                var eventData = event.data;
                return wixLog(WixEventType.PREMIUM_CONTACT_US, {
                    from_step: eventData.fromStep
                });
            }
            case AppEventType.PACKAGE_PICKER_LOAD_START: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_LOAD_START, {
                    origin: eventData.origin
                });
            }
            case AppEventType.PACKAGE_PICKER_LOAD_SUCCESS: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_LOAD_SUCCESS, {
                    tts: eventData.tts,
                    origin: eventData.origin,
                });
            }
            case AppEventType.PACKAGE_PICKER_HOVER_ON_PACKAGE: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_HOVER_ON_PACKAGE, {
                    origin: eventData.origin,
                    package_id: eventData.packageId,
                });
            }
            case AppEventType.PACKAGE_PICKER_SELECT_PACKAGE: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_SELECT_PACKAGE, {
                    package_id: eventData.packageId,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    payment_cycle: eventData.paymentCycle
                });
            }
            case AppEventType.PACKAGE_PICKER_SELECT_TEAM_SIZE: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_SELECT_TEAM_SIZE, {
                    origin: eventData.origin,
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    team_size: eventData.teamSize,
                });
            }
            case AppEventType.PACKAGE_PICKER_SELECT_SUBSCRIPTION_CYCLE: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_SELECT_SUBSCRIPTION_CYCLE, {
                    origin: eventData.origin,
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    team_size: eventData.teamSize,
                });
            }
            case AppEventType.PACKAGE_PICKER_ORDER_PREVIEW_RENDERED: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_ORDER_PREVIEW_RENDERED, {
                    origin: eventData.origin,
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    team_size: eventData.teamSize,
                    preview_id: eventData.previewId,
                    tts: eventData.tts
                });
            }
            case AppEventType.PACKAGE_PICKER_ENTERPRISE_REQUEST_CALLBACK: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_ENTERPRISE_REQUEST_CALLBACK, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                });
            }
            case AppEventType.PACKAGE_PICKER_CHECKOUT_ATTEMPT: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_CHECKOUT_ATTEMPT, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize
                });
            }
            case AppEventType.PACKAGE_PICKER_CHECKOUT_SUCCESS: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_CHECKOUT_SUCCESS, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    tts: eventData.tts,
                });
            }
            case AppEventType.PACKAGE_PICKER_CHECKOUT_FAIL: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_CHECKOUT_FAIL, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                });
            }
            case AppEventType.PACKAGE_PICKER_PURCHASE_ATTEMPT: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_PURCHASE_ATTEMPT, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                });
            }
            case AppEventType.PACKAGE_PICKER_PURCHASE_SUCCESS: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_PURCHASE_SUCCESS, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    tts: eventData.tts
                });
            }
            case AppEventType.PACKAGE_PICKER_PURCHASE_FAIL: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_PURCHASE_FAIL, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    reason: eventData.reason,
                });
            }
            case AppEventType.PACKAGE_PICKER_PURCHASE_MODAL_LINK_CLICK: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_PURCHASE_MODAL_LINK_CLICK, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    modal_name: eventData.modalName,
                    link_name: eventData.linkName
                });
            }
            case AppEventType.PACKAGE_PICKER_PREVIOUS_STEP: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_PREVIOUS_STEP, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    from_step: eventData.fromStep,
                });
            }
            case AppEventType.PACKAGE_PICKER_HOVER_WHATS_INSIDE: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_HOVER_WHATS_INSIDE, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    from_step: eventData.fromStep,
                });
            }
            case AppEventType.PACKAGE_PICKER_VAT_CHANGED: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_VAT_CHANGED, {
                    package_id: eventData.packageId,
                    payment_cycle: eventData.paymentCycle,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    billing_country: eventData.billingCountry,
                    current_vat: eventData.currentVat,
                    previous_vat: eventData.previousVat,
                });
            }
            case AppEventType.PACKAGE_PICKER_PREVIEW_RENDER_FAIL: {
                var eventData = event.data;
                return wixLog(WixEventType.PACKAGE_PICKER_PREVIEW_RENDER_FAIL, {
                    package_id: eventData.packageId,
                    origin: eventData.origin,
                    team_size: eventData.teamSize,
                    payment_cycle: eventData.paymentCycle
                });
            }
            case AppEventType.PREMIUM_SELECT_TEAM_SIZE: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_SELECT_TEAM_SIZE, __assign({}, premiumFields));
            }
            case AppEventType.PREMIUM_SELECT_CUSTOM_PLAN_PRODUCT: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_SELECT_CUSTOM_PLAN_PRODUCT, __assign(__assign({}, premiumFields), { checked_product: eventData.checkedProduct }));
            }
            case AppEventType.PREMIUM_UNSELECT_CUSTOM_PLAN_PRODUCT: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_UNSELECT_CUSTOM_PLAN_PRODUCT, __assign(__assign({}, premiumFields), { unchecked_product: eventData.uncheckedProduct }));
            }
            case AppEventType.PREMIUM_SELECT_PLAN_TYPE: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_SELECT_PLAN_TYPE, __assign(__assign({}, premiumFields), { unlimited_selected: eventData.unlimitedSelected }));
            }
            case AppEventType.PREMIUM_SELECT_SUBSCRIPTION_PLAN: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_SELECT_SUBSCRIPTION_PLAN, __assign({}, premiumFields));
            }
            case AppEventType.PREMIUM_CLOSE_PP: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_CLOSE_PP, __assign({}, premiumFields));
            }
            case AppEventType.PREMIUM_CLOSE_AFTER_SUCCESS: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_CLOSE_AFTER_SUCCESS, __assign({}, premiumFields));
            }
            case AppEventType.PREMIUM_PROCEED_TO_CHECKOUT: {
                var eventData = event.data;
                var premiumFields = biPremiumFields(eventData);
                return wixLog(WixEventType.PREMIUM_PROCEED_TO_CHECKOUT, __assign({}, premiumFields));
            }
            case AppEventType.SETTINGS_SAVE_ATTEMPT: {
                var eventData = event.data;
                return wixLog(WixEventType.APP_SETTINGS_CHANGE_ATTEMPT, __assign({}, settingsSaveFields(eventData)));
            }
            case AppEventType.SETTINGS_SAVE_SUCCESS: {
                var eventData = event.data;
                return wixLog(WixEventType.APP_SETTINGS_CHANGE_SUCCESS, __assign({}, settingsSaveFields(eventData)));
            }
            case AppEventType.SETTINGS_SAVE_FAILURE: {
                var eventData = event.data;
                return wixLog(WixEventType.APP_SETTINGS_CHANGE_FAIL, __assign({}, settingsSaveFields(eventData)));
            }
            case AppEventType.ROLES_SETTINGS_CLICK: {
                return wixLog(WixEventType.APP_SETTINGS_ROLES_CLICK, {});
            }
            case AppEventType.ROLES_SELECT_ADD_CUSTOM_ROLE: {
                return wixLog(WixEventType.APP_SETTINGS_ROLES_SELECT_ADD_CUSTOM_ROLE, {});
            }
            case AppEventType.ROLES_SELECT_EDIT: {
                var role = event.data.role;
                return wixLog(WixEventType.APP_SETTINGS_ROLES_SELECT_EDIT, {
                    role_name: role.name,
                    role_id: role.id
                });
            }
            case AppEventType.PREMIUM_INCENTIVE_CTA_CLICK: {
                return wixLog(WixEventType.PREMIUM_INCENTIVE_CTA, {
                    is_eligible: event.data.isEligible,
                    is_premium: event.data.isPremium,
                    feature: event.data.featureKey
                }, true);
            }
            case AppEventType.PREMIUM_INCENTIVE_CONTACT_CLICK: {
                return wixLog(WixEventType.PREMIUM_INCENTIVE_CONTACT_US_CLICK, {
                    is_eligible: event.data.isEligible,
                    is_premium: event.data.isPremium,
                    feature: event.data.featureKey
                }, true);
            }
            case AppEventType.PREMIUM_INCENTIVE_VIEW: {
                return wixLog(WixEventType.PREMIUM_INCENTIVE_VIEW, {
                    is_eligible: event.data.isEligible,
                    is_premium: event.data.isPremium,
                    feature: event.data.featureKey
                }, true);
            }
            case AppEventType.CREDITS_INCENTIVE_CTA_CLICK: {
                return wixLog(WixEventType.CREDITS_INCENTIVE_CTA, {
                    is_eligible: event.data.isEligible,
                    is_premium: event.data.isPremium,
                    feature: event.data.featureKey
                });
            }
            case AppEventType.CREDITS_INCENTIVE_VIEW: {
                return wixLog(WixEventType.CREDITS_INCENTIVE_VIEW, {
                    is_eligible: event.data.isEligible,
                    is_premium: event.data.isPremium,
                    feature: event.data.featureKey
                });
            }
            case AppEventType.CREDITS_MODAL_OPEN: {
                return wixLog(WixEventType.CREDITS_MODAL_OPEN, {
                    current_balance: event.data.currentBalance,
                    is_premium: event.data.isPremium,
                    origin: event.data.origin
                });
            }
            case AppEventType.CREDITS_MODAL_CLOSED: {
                return wixLog(WixEventType.CREDITS_MODAL_CLOSED, {
                    current_balance: event.data.currentBalance,
                    is_premium: event.data.isPremium,
                    origin: event.data.origin
                });
            }
            case AppEventType.CREDITS_MODAL_CTA_CLICK: {
                return wixLog(WixEventType.CREDITS_MODAL_CTA_CLICK, {
                    current_balance: event.data.currentBalance,
                    is_premium: event.data.isPremium,
                    origin: event.data.origin
                });
            }
            case AppEventType.CREDITS_MODAL_OPEN_PACKAGE_PICKER: {
                return wixLog(WixEventType.CREDITS_MODAL_OPEN_PACKAGE_PICKER, {
                    current_balance: event.data.currentBalance,
                    origin: event.data.origin
                });
            }
            case AppEventType.CREDITS_MODAL_SELECT_AMOUNT: {
                return wixLog(WixEventType.CREDITS_MODAL_SELECT_AMOUNT, {
                    credits_amount: event.data.selectedAmount,
                    current_balance: event.data.currentBalance,
                    origin: event.data.origin
                });
            }
            case AppEventType.CREDITS_MODAL_CLICK_CHECKOUT: {
                return wixLog(WixEventType.CREDITS_MODAL_CLICK_CHECKOUT, {
                    credits_amount: event.data.selectedAmount,
                    current_balance: event.data.currentBalance,
                    origin: event.data.origin
                });
            }
            case AppEventType.CREDIT_PURCHASE_SUCCESS_OPEN: {
                return wixLog(WixEventType.CREDIT_PURCHASE_SUCCESS_OPEN, {});
            }
            case AppEventType.CREDIT_PURCHASE_FAIL_OPEN: {
                return wixLog(WixEventType.CREDIT_PURCHASE_FAIL_OPEN, {});
            }
            case AppEventType.TEAM_MEMBERS_SENT_INVITES: {
                return wixLog(WixEventType.APP_TEAM_MEMBERS_INVITES_SENT, {
                    count_admins: event.data.adminsCount,
                    count_agents: event.data.agentsCount,
                    permission_level: event.data.permissionLevel
                });
            }
            case AppEventType.TEAM_MEMBERS_CREATED_GROUP: {
                return wixLog(WixEventType.APP_TEAM_MEMBERS_CREATED_GROUP, {
                    group_name: event.data.groupName,
                    group_id: event.data.groupId,
                    permission_level: event.data.permissionLevel
                });
            }
            case AppEventType.TEAM_MEMBERS_ADDED_GROUP_MEMBER: {
                return wixLog(WixEventType.APP_TEAM_MEMBERS_ADDED_GROUP_MEMBER, {
                    group_name: event.data.groupName,
                    current_members_count: event.data.currentMembersCount,
                    group_id: event.data.groupId,
                    permission_level: event.data.permissionLevel
                });
            }
            case AppEventType.FTUE_LIGHTBOX_CLOSE: {
                return wixLog(WixEventType.APP_FTUE_LIGHTBOX_CLOSE, {
                    feature: event.data.feature
                });
            }
            case AppEventType.FTUE_LIGHTBOX_PLAY: {
                return wixLog(WixEventType.APP_FTUE_LIGHTBOX_PLAY, {
                    feature: event.data.feature
                }, true);
            }
            case AppEventType.FTUE_LIGHTBOX_VIEW: {
                return wixLog(WixEventType.APP_FTUE_LIGHTBOX_VIEW, {
                    feature: event.data.feature
                }, true);
            }
            case AppEventType.ONBOARDING_WELCOME_SCREEN: {
                return wixLog(WixEventType.APP_WELCOME_SCREEN_VIEW, {
                    type: event.data.type
                }, true);
            }
            case AppEventType.DUMMY_ONE:
            case AppEventType.HINT_LINK_CLICKED:
                // temporarily not handled - waiting for wix bi event
                return Promise.resolve();
        }
    };
};
//# sourceMappingURL=wix.js.map